import { useLayoutEffect, useState } from 'react';
import { usePublicProfileData } from '@/context/PublicProfileContext';
import { CreatorNav } from '@/components/shared/CreatorNav';
import { Hero } from '@/components/home/Hero';
import { Highlights } from '@/components/home/Highlights';
import { Events } from '@/components/home/Events';
import { Platforms } from '@/components/home/Platforms';
import { Socials } from '@/components/home/Socials';
import { GutterDoodles } from '@/components/home/GutterDoodles';
import { Contact } from '@/components/home/Contact';
import { ComingSoon } from '@/components/home/ComingSoon';
import { ShareSheet } from '@/components/shared/ShareSheet';

export function ProfileView() {
  const [shareOpen, setShareOpen] = useState(false);
  const { profile, releases, events, links, contacts } = usePublicProfileData();

  const theme = profile.theme;
  useLayoutEffect(() => {
    if (theme !== 'paper') {
      document.documentElement.dataset.profileTheme = theme;
    }
    return () => {
      delete document.documentElement.dataset.profileTheme;
    };
  }, [theme]);
  const hasContent =
    releases.length > 0 ||
    events.length > 0 ||
    links.length > 0 ||
    contacts.length > 0;

  return (
    <div className="ap-page">
      <CreatorNav onShare={() => setShareOpen(true)} />
      <ShareSheet
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={window.location.href}
      />
      <GutterDoodles />
      <main className="ap-main">
        {/* Merch + Newsletter are out of MVP (need billing/store) — omitted. */}
        <Hero />
        <Socials />
        {hasContent ? (
          <>
            <Highlights />
            <Events />
            <Platforms />
            <Contact />
          </>
        ) : (
          <ComingSoon />
        )}
      </main>
    </div>
  );
}
